import React, { useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { ChatBubbleIcon } from '@rsos/assets/icons';
import { Box } from '@rsos/components/capstone/base';
import { useLazyEndConversationQuery } from '@rsos/reduxDataStore/src/features/textFrom911/textFrom911Api';
import { useSelectedTextFrom911Conversation } from '@rsos/reduxDataStore/src/features/textFrom911/textFrom911Selectors';
import { TF911_CONVERSATION_ENDED } from '@rsos/reduxDataStore/src/features/textFrom911/textFrom911Slice';
import { selectUserOrgByApp } from '@rsos/sinatra';
import { EndChatButton, EndChatContainer } from './TF911.styles';
import { TF911_CHAT_HEADER_HEIGHT } from './TF911ChatBox';
import TF911EndChatModal from './TF911EndChatModal';

const TF911EndChat = ({ isChatBoxVisible, callerID }) => {
  const [showEndConversationModal, setShowConversationModal] = useState(false);

  const orgName = useSelector(
    state =>
      selectUserOrgByApp(
        state.sinatra,
        state.sinatra.user.currentRole.application,
      ).name,
  );
  const conversation = useSelectedTextFrom911Conversation(callerID);

  const isEndingConversation = useMemo(
    () => conversation?.loading?.endConversation,
    [conversation],
  );

  const isConversationEnded = useMemo(
    () => conversation?.data?.custom?.STATUS === TF911_CONVERSATION_ENDED,
    [conversation],
  );

  const handleEndConversation = useCallback(() => {
    triggerEndConversation({ callerID, orgName }).then(() => {
      setShowConversationModal(false);
    });
  }, [callerID, orgName, triggerEndConversation]);

  const [triggerEndConversation] = useLazyEndConversationQuery();

  const handleEndChatBtnClick = useCallback(() => {
    setShowConversationModal(prev => !prev);
  }, []);

  return (
    <EndChatContainer>
      <Box
        alignSelf="center"
        borderRadius="0 0 5px 5px"
        horizontal
        px="12px"
        width="100%"
      >
        <EndChatButton
          btnType="warning_tertiary"
          disabled={isEndingConversation || isConversationEnded}
          isLoadingProp={isEndingConversation}
          noMargin
          onClick={handleEndChatBtnClick}
          size="med"
          grow
          width="100%"
        >
          <ChatBubbleIcon color="lightDanger" />
          <Box px="2px" />
          End Chat
        </EndChatButton>
      </Box>

      <TF911EndChatModal
        callerID={callerID}
        isOpened={showEndConversationModal}
        isLoading={isEndingConversation}
        onClose={handleEndChatBtnClick}
        onConfirm={handleEndConversation}
      />
    </EndChatContainer>
  );
};

export default TF911EndChat;
